import { TARGETING_PLATFORMS } from 'components/Recommendations/Campaign/Edit/CampaignForm/Targeting/targeting'
import { isExactRatioMatch } from '../Media/media'

// A carousel card holds exactly one image, and Google only accepts a
// single-image card when that image is square — a non-square card image would
// have to be accompanied by 1.91:1 and 4:5 variants, which a card can't carry.
export const CAROUSEL_GOOGLE_RATIO = '1:1'

export const carouselTargetsGoogle = (platforms) =>
  Array.isArray(platforms) && platforms.includes(TARGETING_PLATFORMS.google)

export const isVideoCarouselMedia = (media) => Boolean(media?.type?.startsWith?.('video/'))

export const isSquareCarouselMedia = (media) =>
  isExactRatioMatch(media, CAROUSEL_GOOGLE_RATIO)
